import React from "react";
import { number, func, object } from "prop-types";
import { isLastPage, isFirstPage, totalPages, pageBlock } from "../paging";

const propTypes = {
  totalResults: number.isRequired,
  resultsPerPage: number.isRequired,
  currentPage: number.isRequired,
  handlePageChange: func.isRequired,
  dictionary: object
};

const Pagination = ({
  totalResults,
  resultsPerPage,
  currentPage,
  handlePageChange,
	dictionary
}) => {

  const block = pageBlock(totalResults, resultsPerPage, currentPage);
  const isLast = isLastPage(totalResults, resultsPerPage, currentPage);
  const isFirst = isFirstPage(currentPage);
  const lastPage = totalPages(totalResults, resultsPerPage);

  function getPage(label, value, isDisabled) {
    return (
      <button
        className="btn btn--link"
        key={label}
        type="button"
        onClick={() => onPageClick(value, isDisabled)}
        disabled={isDisabled}>{label}</button>
    );
  }

  function onPageClick(pageNum, isDisabled) {
    if (!isDisabled) {
      handlePageChange(pageNum);
    }
  }

	return (
    <div className="search-results__pagination">
      <div className="search-results__pages">
        {getPage(dictionary.firstPageLabel, 1, isFirst)}
        {getPage(dictionary.previousPageLabel, currentPage - 1, isFirst)}
        {block.map( page => getPage(page.label, page.num, page.current))}
        {getPage(dictionary.nextPageLabel, currentPage + 1, isLast)}
        {getPage(dictionary.lastPageLabel, lastPage, isLast)}
      </div>
    </div>
  );
};

Pagination.propTypes = propTypes;

export default Pagination;
